import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { usersRepo } from '@/constants/providers';
import { TaskUser } from '@/modules/Users/domain';
import { DataWithPagination } from '@/shared/types';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { UserKey } from './types';

type UseGetUsersByTaskProps = {
  taskId: number;
  pageNumber?: number;
  filter?: string;
  sortBy?: string;
  sortOrder?: SortDirection;
};

export const useGetUsersByTask = ({
  taskId,
  pageNumber,
  filter,
  sortBy,
  sortOrder,
}: UseGetUsersByTaskProps) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery<DataWithPagination<TaskUser[]>>(
    [
      ...UserKey.BY_TASK_PAGED(taskId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      usersRepo.getUsersByTask(taskId, pageNumber, filter, sortBy, sortOrder),
    {
      cacheTime: 1000 * 60 * 5,
    },
  );
};
